export const AccountOptionValues = {
  APPS: '/apps',
  BUNDLES: '/bundles/listings',
  CONCEPTS: '/concepts',
  CREATE: '/create',
  EXPLORE: '/explore',
  FAVORITES: '/favorites',
  VISUALS: '/visuals',
  DOCS: '/docs',
  MY_APPS: '/my-apps',
  SEARCH: 'search',
  SIGN_OUT: 'sign-out'
};

export const AccountOptionNames = {
  [AccountOptionValues.APPS]: 'Apps',
  [AccountOptionValues.BUNDLES]: 'Bundles',
  [AccountOptionValues.CREATE]: 'Create App',
  [AccountOptionValues.CONCEPTS]: 'Concepts',
  [AccountOptionValues.FAVORITES]: 'Favorites',
  [AccountOptionValues.VISUALS]: 'Visuals',
  [AccountOptionValues.DOCS]: 'Docs',
  [AccountOptionValues.MY_APPS]: 'My Apps',
  [AccountOptionValues.SIGN_OUT]: 'Sign Out',
  [AccountOptionValues.SEARCH]: 'Search'
};

export const VisibilityOptionValues = {
  PASSWORD_PROTECTED: 'password-protected',
  PRIVATE: 'private',
  PUBLIC: 'public'
};

export const VisibilityOptionName = {
  all: 'All',
  [VisibilityOptionValues.PASSWORD_PROTECTED]: 'Password-protected',
  [VisibilityOptionValues.PRIVATE]: 'Private',
  [VisibilityOptionValues.PUBLIC]: 'Public'
};

export const VisibilityOptions = [
  {
    label: VisibilityOptionName.all,
    value: null
  },
  {
    label: VisibilityOptionName[VisibilityOptionValues.PUBLIC],
    value: VisibilityOptionValues.PUBLIC
  },
  {
    label: VisibilityOptionName[VisibilityOptionValues.PRIVATE],
    value: VisibilityOptionValues.PRIVATE
  },
  {
    label: VisibilityOptionName[VisibilityOptionValues.PASSWORD_PROTECTED],
    value: VisibilityOptionValues.PASSWORD_PROTECTED
  }
];
